var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlant(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1736239592175,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 10965,
    width: 32,
    height: 32,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M128 554.666667a384 384 0 0 0 384 384 384 384 0 0 0-384-384m384 384a384 384 0 0 0 384-384 384 384 0 0 0-384 384z m256-810.666667v213.333333A256 256 0 0 1 256 341.333333V128a242.005333 242.005333 0 0 1 92.16 16.64 179.2 179.2 0 0 1 61.866667 42.666667L512 85.333333l101.973333 101.973334a179.2 179.2 0 0 1 61.866667-42.666667A242.005333 242.005333 0 0 1 768 128z",
    "p-id": 10966,
    fill: "#46766A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlant);
export default __webpack_public_path__ + "static/media/Plant.8d37db667269fb2313af45ceacb99fcb.svg";
export { ForwardRef as ReactComponent };